import React, { useEffect, useState } from "react";
import { getOccurrencesCounter, sortObj, capitalizeAllFirstLetter } from "../../Utility/utils"
import Checkboxes from '../checkboxes/checkboxes.component';
import FilterListIcon from '@material-ui/icons/FilterList';

/*
This Component renders the Filters on the Map Page
It is an Unordered List with 5 List items. Each item has: 
 - A label for the name of the event category.
 - An input of type 'checkmark' to store the value of the selected event.
 - A span, which is responsible for the styling of the checkmark.
*/

/**
 *When the component is loaded, the prepareData is called by using useEffect. UseEffect takes the data from the Map (eventsData)
 and calls this function which prepares the Array to pass to the list of the Map.
 */

function MapFilters({ eventsData, handleFiltersData, dateFilteredData, getMarkersSvg }) {

    const [data, setData] = useState([]);
    const ALL_EVENTS = 'all_events';
    const prepareData = (data) => {
       
        const category_data = [];
        const categories = (data.map((item) => item['eventType'].toLowerCase()));
        /*This returns an object with the names of the categories and the occurrences. So,
        we know how many earthquakes there are in the array of the events, how many floods, how many eruptions.*/
        const occ_data = getOccurrencesCounter(categories);
        /*We add all_events. In this way we have the total number of all the events.
        Then we order them in an alphabetic way in the cycle "entries". We iterate this array
        and prepare that one to pass to the list in the html. 
        We will have something like this: [{category: 'Eartquake', total: 2}, {category: 'xxx', total: 3}]
        */
        occ_data[ALL_EVENTS] = data.length;
        const sorted_obj = sortObj(occ_data);

        Object.entries(sorted_obj).forEach(([key, value]) => {

            category_data.push({
                //every checkbox wants:
                id: key,
                category:  capitalizeAllFirstLetter(key.split("_").join(" ")),
                total: value,
                icon: getMarkersSvg(key.toLowerCase()),
                //when we click on a nation, the filter is set on ALL_EVENTS
                isChecked: key === ALL_EVENTS ? true : false
            });
        });

        setData(category_data); // WHEN THIS ARRAY IS READY, WE PASS IT TO SETDATA
    }
//it's called everytime we click on a checkbox 
    const handleCheckboxChange = event => {
// I check if the element is clicked is == to ALL_EVENTS
        const checkAll = event.target.value === ALL_EVENTS;
// I call the Hook. Prevdata = old data
        setData((prevData) => prevData.map(item => {
            // if the checkall has been clicked, I have to change the status.
                if(checkAll) { // if all events is true, all the other chebox are deselected. 
                 
                    return {...item, isChecked: item.id === ALL_EVENTS ? true : false }
                }
                else
                {
                    if(item.id === ALL_EVENTS) {
                        return { ...item, isChecked: false }
                    }
                    return item.id === event.target.value ? { ...item, isChecked: event.target.checked } : item;
                }
            })
        );
      };


    useEffect(() => {
     if (dateFilteredData.length === 0) {
        prepareData(eventsData);
     }
        else {
            prepareData(dateFilteredData)
        }
      },[eventsData, dateFilteredData]);


      useEffect(() => {
        handleFiltersData(data);
    }, [data]);

    return (
        <div className="map-filters-hoverable">
            {/* <i className="fas fa-align-justify" id="mapfilter-AFonts"></i> */}
            <FilterListIcon fontSize="large" id="mapfilter-AFonts" />
            <div className="map-filters-active d-flex flex-column">
                <Checkboxes data={data} handleCheckboxChange={handleCheckboxChange}/>
            </div>
        </div>
    )
}

export default MapFilters;